module.exports = __webpack_public_path__ + "img/board5-GLX-pink-49-thumb.599c5a67.jpg";